import InputField from "../../../../common/InputField";
import React from "react";

const CommissionDetails = () =>{
    return (
        <div className="basic-details-wrapper">
            <h3>Commission Details</h3>
            <InputField
                name={['commission']}
                label={'Commission Percentage'}
                isDisabled={true}
            />
        </div>
    );
};
export default CommissionDetails;